/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const MaintenanceHoursSummaryResourceR = t.interface({
  annual_hours_limit: t.string,

  extra_hours: t.string,

  remaining_hours: t.string,

  scheduled_hours: t.string,

  used_hours: t.string
});

// optional attributes
const MaintenanceHoursSummaryResourceO = t.partial({});

export const MaintenanceHoursSummaryResource = t.intersection(
  [MaintenanceHoursSummaryResourceR, MaintenanceHoursSummaryResourceO],
  "MaintenanceHoursSummaryResource"
);

export type MaintenanceHoursSummaryResource = t.TypeOf<
  typeof MaintenanceHoursSummaryResource
>;
